<div class="login-wrapper">

  <form class="login-card" (ngSubmit)="submit()">

    <h2>{{ t('forgotPasswordTitle') }}</h2>

    <p class="hint">{{ t('forgotPasswordHint') }}</p>

    <input
      [(ngModel)]="email"
      name="email"
      type="email"
      [placeholder]="t('yourEmail')"
      required>

    <button type="submit" [disabled]="loading">
      {{ loading ? t('sending') : t('sendResetLink') }}
    </button>

    <p class="success-msg" *ngIf="message">{{ message }}</p>
    <p class="error-msg" *ngIf="error">{{ error }}</p>

    <div class="register-link">
      <a routerLink="/login">{{ t('backToLogin') }}</a>
    </div>

  </form>

</div>
